import * as actionTypes from './ActionTypes'

export const setShareLink = (data) => {
  return {
    type: actionTypes.SET_SHARE_LINK,
    payload: { data },
  }
}
